  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
//import Checkbox                                            from '@material-ui/core/Checkbox';
  import Radio                                               from '@material-ui/core/Radio';
  import RadioGroup                                          from '@material-ui/core/RadioGroup';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  import Typography                                          from '@material-ui/core/Typography';
  import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
  import InputLabel                                          from '@material-ui/core/InputLabel';
  import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
  import FormControl                                         from '@material-ui/core/FormControl';
  import Select                                              from '@material-ui/core/Select';
  import Autocomplete                                        from '@material-ui/lab/Autocomplete';
  import { createFilterOptions }                             from '@material-ui/lab/Autocomplete';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
//import SnackbarContent                                            from '@material-ui/core/SnackbarContent';

  import MuiAlert                                            from '@material-ui/lab/Alert';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_CountriesStatesCitiesService }                 from "../../_services";
  import { wu_CurrenciesService }                            from "../../_services";
  import { wu_HistoryService }                               from "../../_services";
  //------
  // Style
  //------
  import HistoryChangeStyle                                  from "./HistoryChangeStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import KeyboardBackspaceIcon                               from '@material-ui/icons/KeyboardBackspace'; //[goBack]
  //----------
  // variables
  //----------
  const filename = "HistoryChange ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  //[flagsimages]
  var images = null;

class HistoryChange extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      picker1_textFieldLabel1_id                           : "", //Payment Method
      picker1_textFieldLabel1_text                         : "",
      picker1_textFieldLabel1_hasError                     : false,

      picker2a_selIndex                                    : 0,  //Country
      picker2a_textFieldLabel1_id                          : "",
      picker2a_textFieldLabel1_text                        : "",
      picker2a_textFieldLabel1_hasError                    : false,
      picker2a_AUTOCOMPLETE_MODE                           : "object", //"text","object";
      picker2a_AUTOCOMPLETE_FILTER_OPTIONS                 : "any",    //"start","any"
      picker3a_selIndex_currencyReceive                    : 0,  //3-Receive Currency
      picker3a_textFieldLabel1_id                          : "",
      picker3a_textFieldLabel1_text                        : "",
      picker3a_textFieldLabel1_hasError                    : false,
      picker4a_selIndex_State                              : 0,  //4-State
      picker4a_textFieldLabel1_id                          : "",
      picker4a_textFieldLabel1_text                        : "",
      picker4a_textFieldLabel1_hasError                    : false,
      picker5a_selIndex_City                               : 0,  //5-City
      picker5a_textFieldLabel1_id                          : "",
      picker5a_textFieldLabel1_text                        : "",
      picker5a_textFieldLabel1_hasError                    : false,

      viewStatea_isHidden                                  : true,
      viewCitya_isHidden                                   : true,

      picker2b_selIndex                                    : 0,  //Country
      picker2b_textFieldLabel1_id                          : "",
      picker2b_textFieldLabel1_text                        : "",
      picker2b_textFieldLabel1_hasError                    : false,
      picker2b_AUTOCOMPLETE_MODE                           : "object", //"text","object";
      picker2b_AUTOCOMPLETE_FILTER_OPTIONS                 : "any",    //"start","any"
      picker3b_selIndex_currencyReceive                    : 0,  //3-Receive Currency
      picker3b_textFieldLabel1_id                          : "",
      picker3b_textFieldLabel1_text                        : "",
      picker3b_textFieldLabel1_hasError                    : false,
      picker4b_selIndex_State                              : 0,  //4-State
      picker4b_textFieldLabel1_id                          : "",
      picker4b_textFieldLabel1_text                        : "",
      picker4b_textFieldLabel1_hasError                    : false,
      picker5b_selIndex_City                               : 0,  //5-City
      picker5b_textFieldLabel1_id                          : "",
      picker5b_textFieldLabel1_text                        : "",
      picker5b_textFieldLabel1_hasError                    : false,

      viewStateb_isHidden                                  : true,
      viewCityb_isHidden                                   : true,

      textField1                                           : "",   //Current MTCN
      textField1_hasError                                  : false,
      textField2                                           : "",   //Current First Name
      textField2_hasError                                  : false,
      textField3                                           : "",   //Current Last Name
      textField3_hasError                                  : false,
      textField4                                           : "",   //New First Name
      textField4_hasError                                  : false,
      textField5                                           : "",   //New Last Name
      textField5_hasError                                  : false,

      textField4_disabled                                  : false,
      textField5_disabled                                  : false,
      picker2b_disabled                                    : true,
      picker3b_disabled                                    : true,

      changeReceiver_value                                 : "true",
      changeDestination_value                              : "",

      parserObject_getPaymentMethods                       : [],
      parserObject_getCountries                            : [],
      parserObject_getCountries4Picker                     : [],
      parserObject_getStatesa                              : [],
      parserObject_getStatesb                              : [],
      parserObject_getStates4Pickera                       : [],
      parserObject_getStates4Pickerb                       : [],
      parserObject_getCitiesa                              : [],
      parserObject_getCitiesb                              : [],
      parserObject_getCities4Pickera                       : [],
      parserObject_getCities4Pickerb                       : [],
      parserObject_getCurrencies_ALL                       : [],
      parserObject_getCurrencies                           : [],
      parserObject_getCurrencies4Picker                    : [],
      parserObject_getCurrencies_b                         : [],
      parserObject_getCurrencies4Picker_b                  : [],

      dialog2_msg                                          : "",
      dialog2_isOpen                                       : false,
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                 = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                = this.dialog_handleClose.bind(this);
    this.startSpinners                                     = this.startSpinners.bind(this);
    this.stopSpinners                                      = this.stopSpinners.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                                         = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                                        = this.dialog200_handleClose.bind(this);

    //[goBack]
    this.goBack                                            = this.goBack.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                     = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                    = this.Snackbar_textField_handleClose.bind(this);

    this.handleCustomDropDownClick_paymentMethod           = this.handleCustomDropDownClick_paymentMethod.bind(this);
    this.handleCustomDropDownClick_countrya                = this.handleCustomDropDownClick_countrya.bind(this);
    this.handleCustomDropDownClick_statea                  = this.handleCustomDropDownClick_statea.bind(this);
    this.handleCustomDropDownClick_citya                   = this.handleCustomDropDownClick_citya.bind(this);
    this.handleCustomDropDownClick_currencya               = this.handleCustomDropDownClick_currencya.bind(this);

    this.handleCustomDropDownClick_countryb                = this.handleCustomDropDownClick_countryb.bind(this);
    this.handleCustomDropDownClick_stateb                  = this.handleCustomDropDownClick_stateb.bind(this);
    this.handleCustomDropDownClick_cityb                   = this.handleCustomDropDownClick_cityb.bind(this);
    this.handleCustomDropDownClick_currencyb               = this.handleCustomDropDownClick_currencyb.bind(this);

    this.makeHTTPConn_select_COUNTRY_reload_STATE_a        = this.makeHTTPConn_select_COUNTRY_reload_STATE_a.bind(this);
    this.makeHTTPConn_select_STATE_reload_CITY_a           = this.makeHTTPConn_select_STATE_reload_CITY_a.bind(this);
    this.updateUI_select_COUNTRY_reload_CURRENCY           = this.updateUI_select_COUNTRY_reload_CURRENCY.bind(this);

    this.makeHTTPConn_select_COUNTRY_reload_STATE_b        = this.makeHTTPConn_select_COUNTRY_reload_STATE_b.bind(this);
    this.makeHTTPConn_select_STATE_reload_CITY_b           = this.makeHTTPConn_select_STATE_reload_CITY_b.bind(this);
    this.updateUI_select_COUNTRY_reload_CURRENCY_b         = this.updateUI_select_COUNTRY_reload_CURRENCY_b.bind(this);

    this.handleRadioButtonClick_changeReceiver             = this.handleRadioButtonClick_changeReceiver.bind(this);
    this.handleRadioButtonClick_changeDestination          = this.handleRadioButtonClick_changeDestination.bind(this);

    this.btn_next_act                                      = this.btn_next_act.bind(this);
    this.btn_next_act_isDisabled                           = this.btn_next_act_isDisabled.bind(this);

    this.dialog2_handleOpen                                = this.dialog2_handleOpen.bind(this);
    this.dialog2_handleClose                               = this.dialog2_handleClose.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);
    if(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    if(api.print_logs){console.log(methName+localStorage.getItem("curr_view")+",history.length="+history.length);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    if(!wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return;
    }
    //---------------------
    //newCustomer filtering--load Contoller---Exclude(LIGHT,BP)
    //---------------------
    if(api.new_registration_enabled){
      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      let customerLevel = wu_Utilities.textDecisions_customerLevel(api.print_logs,parserObject_validatecustomer);
      if(customerLevel==="LIGHT"){ try {localStorage.setItem("newRegistrationFlow","newCustomer");   }catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
      if(customerLevel==="BP")   { try {localStorage.setItem("newRegistrationFlow","upgradeAccount");}catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
    }
    //--------------------
    //wu_getPaymentMethods---STATIC
    //--------------------
    var res_obj_wu_getPaymentMethods = wu_StaticDataService.wu_getPaymentMethods({});
    this.setState({
      "parserObject_getPaymentMethods"        : res_obj_wu_getPaymentMethods.payment_methods,
      "picker1_textFieldLabel1_text"          : "",
      "picker1_textFieldLabel1_id"            : "",
    });

    //[flagsimages]
    images = this.importAll(require.context('assets/img/flagspng/', false, /\.(png|svg)$/));
    //if(api.print_logs){console.log("images.length="+images.length);}
    //for (var key in images) { if(api.print_logs){console.log("key="+key);} }

    //nailed for testing:START---inactive
    //localStorage.removeItem("countries");
    //localStorage.removeItem("currencies");
    //nailed for TESTING:END

    //------------
    //getCountries---CACHED
    //------------
    let retrieveWSData_getCountries = wu_CountriesStatesCitiesService.wu_should_getCountries();
    if(retrieveWSData_getCountries){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_CountriesStatesCitiesService
      .wu_getCountries({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="HistoryChange"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        var parserObject_getCountries4Picker = [];
        res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      })
      .catch(err => {
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        console.log(methName+"err="+JSON.stringify(err));
        let res = wu_StaticDataService.wu_get_cached_countries({});
        var parserObject_getCountries4Picker= [];
        res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker,
        });
      });
    }
    else{
      try{
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        let res = JSON.parse(localStorage.getItem("countries"));
        var parserObject_getCountries4Picker= [];
        res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      }catch(err){
        console.log('err='+err);
      }
    }
    //-------------
    //getCurrencies---CACHED
    //-------------
    let retrieveWSData_getCurrencies = wu_CurrenciesService.wu_should_getCurrencies();
    if(retrieveWSData_getCurrencies){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_CurrenciesService
      .wu_getCurrencies({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="HistoryChange"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_getCurrencies="+retrieveWSData_getCurrencies);}
        this.setState({ "parserObject_getCurrencies_ALL" : res.countries }); //YES! the subitem is countries!!!
      })
      .catch(err => {
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getCurrencies="+retrieveWSData_getCurrencies);}
        console.log(methName+"err="+JSON.stringify(err));
        let res = wu_StaticDataService.wu_get_cached_currencies({});
        let parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({ "parserObject_getCurrencies_ALL" : res.countries }); //YES! the subitem is countries!!!
      });
    }
    else{
      try{
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_getCurrencies="+retrieveWSData_getCurrencies);}
        let res = JSON.parse(localStorage.getItem("currencies"));
        let parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({ "parserObject_getCurrencies_ALL" : res.countries }); //YES! the subitem is countries!!!
      }catch(err){
        console.log('err='+err);
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    //----------
    //Country_2a
    //----------
    let defaultPropsCountry_a  = {};
    let filterOptionsCountry_a = {};
    if(this.state.picker2a_AUTOCOMPLETE_MODE === "text"){
      defaultPropsCountry_a  = { options:this.state.parserObject_getCountries4Picker, getOptionLabel:option => option,};
      filterOptionsCountry_a = createFilterOptions({matchFrom: this.state.picker2a_AUTOCOMPLETE_FILTER_OPTIONS, stringify: option => option, });
    }
    else{
      if(localStorage.getItem("lang")==="en"){ defaultPropsCountry_a = { options:this.state.parserObject_getCountries, getOptionLabel:option => option.descr_en ? option.descr_en : "", }; }
      else                                   { defaultPropsCountry_a = { options:this.state.parserObject_getCountries, getOptionLabel:option => option.descr_el ? option.descr_el : "", }; }
      filterOptionsCountry_a = createFilterOptions({matchFrom: this.state.picker2a_AUTOCOMPLETE_FILTER_OPTIONS,stringify: (option) => option.descr_el + option.descr_en + option.keywords,});
    }
    //----------
    //Country_2a
    //----------
    let defaultPropsCountry_b  = {};
    let filterOptionsCountry_b = {};
    if(this.state.picker2b_AUTOCOMPLETE_MODE === "text"){
      defaultPropsCountry_b  = { options:this.state.parserObject_getCountries4Picker, getOptionLabel:option => option,};
      filterOptionsCountry_b = createFilterOptions({matchFrom: this.state.picker2b_AUTOCOMPLETE_FILTER_OPTIONS, stringify: option => option, });
    }
    else{
      if(localStorage.getItem("lang")==="en"){ defaultPropsCountry_b = { options:this.state.parserObject_getCountries, getOptionLabel:option => option.descr_en ? option.descr_en : "", }; }
      else                                   { defaultPropsCountry_b = { options:this.state.parserObject_getCountries, getOptionLabel:option => option.descr_el ? option.descr_el : "", }; }
      filterOptionsCountry_b = createFilterOptions({matchFrom: this.state.picker2b_AUTOCOMPLETE_FILTER_OPTIONS,stringify: (option) => option.descr_el + option.descr_en + option.keywords,});
    }



    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            {api.backButtonAtHeader === true ? (
              <GridContainer justify="center">
                <GridItem xs={2} sm={2} md={1}>
                  <div style={{ marginTop:20,marginBottom:10, textAlign:"left" }}>
                    {/* ----------[goBack]------------ */}
                    <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button>
                  </div>
                </GridItem>
                <GridItem xs={10} sm={10} md={11}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("History3_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("History3_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            )}

            {/* -------------------------------------------------- */}
            {/* ----------Payment Details Label------------------- */}
            {/* -------------------------------------------------- */}
            <div style={{ marginTop: 20 }}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.History3_lbl_headerLabel01}>{this.NSInforString("History3_lbl_headerLabel01")}</div>
                </GridItem>
              </GridContainer>
            </div>
            {/* -------------------------------------------------- */}
            {/* ----------MTCN/PaymentMethod---------------------- */}
            {/* -------------------------------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={6}>
                <TextField
                  fullWidth
                  error={this.state.textField1_hasError}
                  className={classes.textField1}
                  id="textField1"
                  label={this.NSInforString("History3_plh01")}
                  defaultValue={this.state.textField1}
                  value={this.state.textField1}
                  InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField1"), type: "text" }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth error={this.state.picker1_textFieldLabel1_hasError} className={classes.picker1_textFieldLabel1}>
                  <InputLabel id="picker0_textFieldLabel1_InputLabel">{this.NSInforString("History3_pic1")}</InputLabel>
                  <Select
                    displayEmpty
                    id="picker1_textFieldLabel1"
                    value={this.state.picker1_textFieldLabel1_text}
                    onChange={event => this.handleCustomDropDownClick_paymentMethod(event)}
                  >
                  {this.state.parserObject_getPaymentMethods.map(function (aVal) {
                    if(localStorage.getItem("lang")==="en") { return <MenuItem key={aVal["descr_en"]} value={aVal["descr_en"]}>{aVal["descr_en"]}</MenuItem>; }
                    else                                    { return <MenuItem key={aVal["descr_en"]} value={aVal["descr_el"]}>{aVal["descr_el"]}</MenuItem>; }
                  })}

                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
            {/* -------------------------------------------------- */}
            {/* ----------Receiver's Data Label------------------- */}
            {/* -------------------------------------------------- */}
            <div style={{ marginTop: 20 }}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.History3_lbl_headerLabel02}>{this.NSInforString("History3_lbl_headerLabel02")}</div>
                </GridItem>
              </GridContainer>
            </div>
            {/* -------------------------------------------------- */}
            {/* ----------firstName/Country----------------------- */}
            {/* -------------------------------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={6}>
                <TextField
                  fullWidth
                  error={this.state.textField2_hasError}
                  className={classes.textField2}
                  id="textField2"
                  label={this.NSInforString("History3_plh03")}
                  defaultValue={this.state.textField2}
                  value={this.state.textField2}
                  InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField2"), type: "text" }}
                />
              </GridItem>
              {this.state.picker2a_AUTOCOMPLETE_MODE === "text" ? (
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth className={classes.picker2_textFieldLabel1}>
                  <Autocomplete
                    {...defaultPropsCountry_a}
                    id="picker2_textFieldLabel1"
                    value={this.state.picker2a_textFieldLabel1_text}
                    disableClearable
                    onChange={(event,value) => this.handleCustomDropDownClick_countrya(event,value)}
                    renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(option).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option}</Typography></React.Fragment>);}}
                    renderInput={params => <TextField {...params} error={this.state.picker2a_textFieldLabel1_hasError} label={this.NSInforString("History3_pic2")} name={"off"+Math.random()} />}
                  />
                </FormControl>
              </GridItem>
              ) : (
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth className={classes.picker2_textFieldLabel1}>
                  <Autocomplete
                    filterOptions={filterOptionsCountry_a}
                    {...defaultPropsCountry_a}
                    id="picker2_textFieldLabel1"
                    value={this.state.picker2a_textFieldLabel1_text}
                    disableClearable
                    onChange={(event,value) => this.handleCustomDropDownClick_countrya(event,value)}
                    renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(option.descr_en).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option.descr_en}</Typography></React.Fragment>);}}
                    renderInput={params => <TextField {...params} error={this.state.picker2a_textFieldLabel1_hasError} label={this.NSInforString("History3_pic2")} name={"off"+Math.random()} />}
                  />
                </FormControl>
              </GridItem>
              ) }
            </GridContainer>
            {/* -------------------------------------------------- */}
            {/* ----------Empty/State----------------------------- */}
            {/* -------------------------------------------------- */}
            {this.state.viewStatea_isHidden === true ? "" :
            (
            <GridContainer justify="center">
              <GridItem xs={6} sm={6} md={6}>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth error={this.state.picker4a_textFieldLabel1_hasError} className={classes.picker4_textFieldLabel1} disabled={this.state.picker4_disabled}>
                  <InputLabel id="picker4_textFieldLabel1_InputLabel">{this.NSInforString("TransferOnline_pic4")}</InputLabel>
                  <Select
                    displayEmpty
                    id="picker4_textFieldLabel1"
                    value={this.state.picker4a_textFieldLabel1_text}
                    onChange={event => this.handleCustomDropDownClick_statea(event)}
                  >
                    {this.state.parserObject_getStates4Pickera.map(function (akey) {
                      return <MenuItem key={akey+Math.random()} value={akey}>{akey}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
            )}
            {/* -------------------------------------------------- */}
            {/* ----------Empty/City------------------------------ */}
            {/* -------------------------------------------------- */}
            {this.state.viewCitya_isHidden === true ? "" :
            (
            <GridContainer justify="center">
              <GridItem xs={6} sm={6} md={6}>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth error={this.state.picker5a_textFieldLabel1_hasError} className={classes.picker5a_textFieldLabel1}>
                  <InputLabel id="picker5a_textFieldLabel1_InputLabel">{this.NSInforString("TransferOnline_pic5")}</InputLabel>
                  <Select
                    displayEmpty
                    id="picker5a_textFieldLabel1"
                    value={this.state.picker5a_textFieldLabel1_text}
                    onChange={event => this.handleCustomDropDownClick_citya(event)}
                  >
                    {this.state.parserObject_getCities4Pickera.map(function (akey) {
                      return <MenuItem key={akey} value={akey}>{akey}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
            )}
            {/* -------------------------------------------------- */}
            {/* ----------lastName/Currency----------------------- */}
            {/* -------------------------------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={6}>
                <TextField
                  fullWidth
                  error={this.state.textField3_hasError}
                  className={classes.textField3}
                  id="textField3"
                  label={this.NSInforString("History3_plh04")}
                  defaultValue={this.state.textField3}
                  value={this.state.textField3}
                  InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField3"), type: "text" }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth error={this.state.picker3a_textFieldLabel1_hasError} className={classes.picker3_textFieldLabel1}>
                  <InputLabel id="picker3_textFieldLabel1_InputLabel">{this.NSInforString("History3_pic3")}</InputLabel>
                  <Select
                    displayEmpty
                    id="picker3_textFieldLabel1"
                    value={this.state.picker3a_textFieldLabel1_text}
                    onChange={event => this.handleCustomDropDownClick_currencya(event)}
                  >
                    {this.state.parserObject_getCurrencies4Picker.map(function (akey) {
                      return <MenuItem value={akey}>{akey}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
            {/* -------------------------------------------------- */}
            {/* ----------New Receiver's Data Label--------------- */}
            {/* -------------------------------------------------- */}
            <div style={{ marginTop: 20 }}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.History3_lbl_headerLabel03}>{this.NSInforString("History3_lbl_headerLabel03")}</div>
                </GridItem>
              </GridContainer>
            </div>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={6}>
                <RadioGroup aria-label="tab1" name="tab1" value={this.state.changeReceiver_value} onChange={this.handleRadioButtonClick_changeReceiver}>
                  <FormControlLabel value="true" control={<Radio />} label={this.NSInforString("History3_lbl_tab01")} />
                </RadioGroup>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <RadioGroup aria-label="tab2" name="tab2" value={this.state.changeDestination_value} onChange={this.handleRadioButtonClick_changeDestination}>
                  <FormControlLabel value="true" control={<Radio />} label={this.NSInforString("History3_lbl_tab02")} />
                </RadioGroup>
              </GridItem>
            </GridContainer>
            {/* -------------------------------------------------- */}
            {/* ----------firstName/Country----------------------- */}
            {/* -------------------------------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={6}>
                <TextField
                  disabled={this.state.textField4_disabled}
                  fullWidth
                  error={this.state.textField4_hasError}
                  className={classes.textField4}
                  id="textField4"
                  label={this.NSInforString("History3_plh03")}
                  defaultValue={this.state.textField4}
                  value={this.state.textField4}
                  InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField4"), type: "text" }}
                />
              </GridItem>
              {this.state.picker2b_AUTOCOMPLETE_MODE === "text" ? (
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth className={classes.picker2b_textFieldLabel1} disabled={this.state.picker2b_disabled}>
                  <Autocomplete
                    disabled={this.state.picker2b_disabled}
                    {...defaultPropsCountry_b}
                    id="picker2b_textFieldLabel1"
                    value={this.state.picker2b_textFieldLabel1_text}
                    disableClearable
                    onChange={(event,value) => this.handleCustomDropDownClick_countryb(event,value)}
                    renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(option).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option}</Typography></React.Fragment>);}}
                    renderInput={params => <TextField {...params} error={this.state.picker2b_textFieldLabel1_hasError} label={this.NSInforString("History3_pic2b")} name={"off"+Math.random()} />}
                  />
                </FormControl>
              </GridItem>
              ) : (
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth className={classes.picker2b_textFieldLabel1} disabled={this.state.picker2b_disabled}>
                  <Autocomplete
                    disabled={this.state.picker2b_disabled}
                    filterOptions={filterOptionsCountry_b}
                    {...defaultPropsCountry_b}
                    id="picker2b_textFieldLabel1"
                    value={this.state.picker2b_textFieldLabel1_text}
                    disableClearable
                    onChange={(event,value) => this.handleCustomDropDownClick_countryb(event,value)}
                    renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(option.descr_en).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option.descr_en}</Typography></React.Fragment>);}}
                    renderInput={params => <TextField {...params} error={this.state.picker2b_textFieldLabel1_hasError} label={this.NSInforString("History3_pic2b")} name={"off"+Math.random()} />}
                  />
                </FormControl>
              </GridItem>
              ) }
            </GridContainer>
            {/* -------------------------------------------------- */}
            {/* ----------Empty/State----------------------------- */}
            {/* -------------------------------------------------- */}
            {this.state.viewStateb_isHidden === true ? "" :
            (
            <GridContainer justify="center">
              <GridItem xs={6} sm={6} md={6}>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth error={this.state.picker4b_textFieldLabel1_hasError} className={classes.picker4b_textFieldLabel1} disabled={this.state.picker4b_disabled}>
                  <InputLabel id="picker4b_textFieldLabel1_InputLabel">{this.NSInforString("TransferOnline_pic4")}</InputLabel>
                  <Select
                    displayEmpty
                    id="picker4b_textFieldLabel1"
                    value={this.state.picker4b_textFieldLabel1_text}
                    onChange={event => this.handleCustomDropDownClick_stateb(event)}
                  >
                    {this.state.parserObject_getStates4Pickerb.map(function (akey) {
                      return <MenuItem key={akey+Math.random()} value={akey}>{akey}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
            )}
            {/* -------------------------------------------------- */}
            {/* ----------Empty/City------------------------------ */}
            {/* -------------------------------------------------- */}
            {this.state.viewCityb_isHidden === true ? "" :
            (
            <GridContainer justify="center">
              <GridItem xs={6} sm={6} md={6}>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth error={this.state.picker5b_textFieldLabel1_hasError} className={classes.picker5b_textFieldLabel1} disabled={this.state.picker5b_disabled}>
                  <InputLabel id="picker5b_textFieldLabel1_InputLabel">{this.NSInforString("TransferOnline_pic5")}</InputLabel>
                  <Select
                    displayEmpty
                    id="picker5b_textFieldLabel1"
                    value={this.state.picker5b_textFieldLabel1_text}
                    onChange={event => this.handleCustomDropDownClick_cityb(event)}
                  >
                    {this.state.parserObject_getCities4Pickerb.map(function (akey) {
                      return <MenuItem key={akey} value={akey}>{akey}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
            )}


            {/* -------------------------------------------------- */}
            {/* ----------lastName/Currency----------------------- */}
            {/* -------------------------------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={6}>
                <TextField
                  disabled={this.state.textField5_disabled}
                  fullWidth
                  error={this.state.textField5_hasError}
                  className={classes.textField5}
                  id="textField5"
                  label={this.NSInforString("History3_plh08")}
                  defaultValue={this.state.textField5}
                  value={this.state.textField5}
                  InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField5"), type: "text" }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth error={this.state.picker3b_textFieldLabel1_hasError} className={classes.picker3b_textFieldLabel1} disabled={this.state.picker3b_disabled}>
                  <InputLabel id="picker3b_textFieldLabel1_InputLabel">{this.NSInforString("History3_pic3b")}</InputLabel>
                  <Select
                    displayEmpty
                    id="picker3b_textFieldLabel1"
                    value={this.state.picker3b_textFieldLabel1_text}
                    onChange={event => this.handleCustomDropDownClick_currencyb(event)}
                  >
                    {this.state.parserObject_getCurrencies4Picker_b.map(function (akey) {
                      return <MenuItem value={akey}>{akey}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
            {/* ------------------------- */}
            {/* ----------[BUTTONS]------ */}
            {/* ------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={10} sm={10} md={10}>
                <div className={classes.textCenter}>
                  <CustomButton
                    disabled={this.btn_next_act_isDisabled()}
                    className={classes.yellowButton}
                    color="rose"
                    onClick={this.btn_next_act}
                    type="submit">
                    {this.NSInforString("History3_btn_next")}
                  </CustomButton>
                </div>
              </GridItem>
            </GridContainer>
            {/* -------------------------------------------------- */}
            {/* ----------[goBack Bottom]------------------------- */}
            {/* -------------------------------------------------- */}
            {api.backButtonAtBottom === true ? (
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={false}
                      className={classes.backButton}
                      color="rose"
                      onClick={this.goBack}>
                      {this.NSInforString("History3_btn_prev")}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            ) : ( "" ) }

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
        {/* -------------------------------------------------- */}
        {/* ----------[POPUP RESEND CONFIRMATION EMAIL]------- */}
        {/* -------------------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog2_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog2_handleClose}
            aria-labelledby="alert-dialog2-slide-title"
            aria-describedby="alert-dialog2-slide-description"
          >
            <DialogTitle id="alert-dialog2-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog2-slide-description">{this.state.dialog2_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog2_handleClose}>{this.NSInforString("alert_OK")}</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  //-------------------------------------------------------------------------------------------------------------------------------
  //-------------------------------------------------------------------------------------------------------------------------------
  makeHTTPConn_select_COUNTRY_reload_STATE_a(ctry_wu_id){
    let methName = filename+"makeHTTPConn_select_COUNTRY_reload_STATE_a ";

    //------------
    //wu_getStates
    //------------
    wu_CountriesStatesCitiesService
    .wu_getStates({country:ctry_wu_id})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="HistoryChange"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      var parserObject_getStates4Pickera= [];
      for(var i=0; i<res.states.length; ++i){ parserObject_getStates4Pickera.push(res.states[i]["state_name"]); }
      this.setState({ "parserObject_getStatesa"        : res.states });
      this.setState({ "parserObject_getStates4Pickera" : parserObject_getStates4Pickera });
    })
    .catch(err => {
      console.log(methName+"err="+JSON.stringify(err));
    });

    if(ctry_wu_id === "US"){this.setState({ "viewStatea_isHidden":false }); this.setState({ "viewCitya_isHidden":true });}//before select state do not show city
    if(ctry_wu_id === "MX"){this.setState({ "viewStatea_isHidden":false }); this.setState({ "viewCitya_isHidden":true });}
    //this.setState({ "viewStateCity_isHidden":false });

    return;
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  makeHTTPConn_select_STATE_reload_CITY_a(ctry_wu_id,state_id){
    let methName = filename+"makeHTTPConn_select_STATE_reload_CITY_a ";

    //------------
    //wu_getCities
    //------------
    wu_CountriesStatesCitiesService
    .wu_getCities({country:ctry_wu_id,state:state_id})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="HistoryChange"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      var parserObject_getCities4Pickera= [];
      for(var i=0; i<res.cities.length; ++i){ parserObject_getCities4Pickera.push(res.cities[i]["descr_en"]); }
      this.setState({ "parserObject_getCitiesa"        : res.cities });
      this.setState({ "parserObject_getCities4Pickera" : parserObject_getCities4Pickera });
    })
    .catch(err => {
      console.log(methName+"err="+JSON.stringify(err));
    });

    if(ctry_wu_id === "US"){this.setState({ "viewStatea_isHidden":false }); this.setState({ "viewCitya_isHidden":false });}//before select state do not show city
    if(ctry_wu_id === "MX"){this.setState({ "viewStatea_isHidden":false }); this.setState({ "viewCitya_isHidden":false });}
    //this.setState({ "viewStateCity_isHidden":false });

    return;
  }
  //----------------------------------------------------------------------------------------------------
  updateUI_select_COUNTRY_reload_CURRENCY(ctry_wu_id){
    let methName = filename+"updateUI_select_COUNTRY_reload_CURRENCY ";
    if(api.print_logs){console.log(methName+'ctry_wu_id='+ctry_wu_id);}

    for (let i=0; i<this.state.parserObject_getCurrencies_ALL.length && ctry_wu_id !==""; ++i) {
        let item = this.state.parserObject_getCurrencies_ALL[i];
        if(ctry_wu_id === item.ctry_wu_id){
            let countryCurrencies = item["currencies"];
            if(countryCurrencies.length===1){
                //localStorage.setItem("parserObject_getCurrencies4CountryRec_isD2B",    item[api.hasD2BfName]===true?"true":"false");
                //localStorage.setItem("parserObject_getCurrencies4CountryRec_localCur", item["localCur"]);
                //this.setState({ "viewTM_view_BA_isHidden" : (item[api.hasD2BfName]===true) ? false : true });

                let parserObject_getCurrencies4Picker= [];
                for(let ii=0; ii<countryCurrencies.length; ++ii){ parserObject_getCurrencies4Picker.push(countryCurrencies[ii]["curr_descr"]); }
                this.setState({
                  "parserObject_getCurrencies"        : countryCurrencies,
                  "parserObject_getCurrencies4Picker" : parserObject_getCurrencies4Picker,
                  "picker3a_selIndex_currencyReceive" : 0,
                  "picker3a_textFieldLabel1_text"     : countryCurrencies[0]["curr_descr"],
                  "picker3a_textFieldLabel1_id"       : countryCurrencies[0]["curr_iso_id"],
                  "picker3a_textFieldLabel1_hasError" : false,
                });
                if(api.print_logs){console.log('[1] ctry_wu_id='+ctry_wu_id+',parserObject_getCurrencies4Picker='+parserObject_getCurrencies4Picker);}
            }
            else if(countryCurrencies.length>1){
                //localStorage.setItem("parserObject_getCurrencies4CountryRec_isD2B",    item[api.hasD2BfName]===true?"true":"false");
                //localStorage.setItem("parserObject_getCurrencies4CountryRec_localCur", item["localCur"]);
                //this.setState({ "viewTM_view_BA_isHidden" : (item[api.hasD2BfName]===true) ? false : true });

                //5Α16
                //countryCurrencies = [{curr_iso_id:"",curr_descr:this.NSInforString("TransferOnline_pic3")}].concat(countryCurrencies);

                let parserObject_getCurrencies4Picker= [];
                for(let ii=0; ii<countryCurrencies.length; ++ii){ parserObject_getCurrencies4Picker.push(countryCurrencies[ii]["curr_descr"]); }
                this.setState({
                  "parserObject_getCurrencies"        : countryCurrencies,
                  "parserObject_getCurrencies4Picker" : parserObject_getCurrencies4Picker,
                  "picker3a_selIndex_currencyReceive" : 0,
                  "picker3a_textFieldLabel1_text"     : countryCurrencies[0]["curr_descr"],
                  "picker3a_textFieldLabel1_id"       : countryCurrencies[0]["curr_iso_id"],
                  "picker3a_textFieldLabel1_hasError" : false,
                });
                if(api.print_logs){console.log('[1] ctry_wu_id='+ctry_wu_id+',parserObject_getCurrencies4Picker='+parserObject_getCurrencies4Picker);}
            }
            break;
        }
    }
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  //-------------------------------------------------------------------------------------------------------------------------------
  //-------------------------------------------------------------------------------------------------------------------------------
  makeHTTPConn_select_COUNTRY_reload_STATE_b(ctry_wu_id){
    let methName = filename+"makeHTTPConn_select_COUNTRY_reload_STATE_b ";

    //------------
    //wu_getStates
    //------------
    wu_CountriesStatesCitiesService
    .wu_getStates({country:ctry_wu_id})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="HistoryChange"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      var parserObject_getStates4Pickerb= [];
      for(var i=0; i<res.states.length; ++i){ parserObject_getStates4Pickerb.push(res.states[i]["state_name"]); }
      this.setState({
        "parserObject_getStatesb"        : res.states,
        "parserObject_getStates4Pickerb" : parserObject_getStates4Pickerb,
      });
    })
    .catch(err => {
      console.log(methName+"err="+JSON.stringify(err));
    });

    if(ctry_wu_id === "US"){this.setState({ "viewStateb_isHidden":false }); this.setState({ "viewCityb_isHidden":true });}//before select state do not show city
    if(ctry_wu_id === "MX"){this.setState({ "viewStateb_isHidden":false }); this.setState({ "viewCityb_isHidden":true });}
    //this.setState({ "viewStateCity_isHidden":false });

    return;
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  makeHTTPConn_select_STATE_reload_CITY_b(ctry_wu_id,state_id){
    let methName = filename+"makeHTTPConn_select_STATE_reload_CITY_b ";

    //------------
    //wu_getCities
    //------------
    wu_CountriesStatesCitiesService
    .wu_getCities({country:ctry_wu_id,state:state_id})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="HistoryChange"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      var parserObject_getCities4Pickerb= [];
      for(var i=0; i<res.cities.length; ++i){ parserObject_getCities4Pickerb.push(res.cities[i]["descr_en"]); }
      this.setState({ "parserObject_getCitiesb"        : res.cities });
      this.setState({ "parserObject_getCities4Pickerb" : parserObject_getCities4Pickerb });
    })
    .catch(err => {
      console.log(methName+"err="+JSON.stringify(err));
    });

    if(ctry_wu_id === "US"){this.setState({ "viewStateb_isHidden":false }); this.setState({ "viewCityb_isHidden":false });}//before select state do not show city
    if(ctry_wu_id === "MX"){this.setState({ "viewStateb_isHidden":false }); this.setState({ "viewCityb_isHidden":false });}
    //this.setState({ "viewStateCity_isHidden":false });

    return;
  }
  //----------------------------------------------------------------------------------------------------
  updateUI_select_COUNTRY_reload_CURRENCY_b(ctry_wu_id){
    let methName = filename+"updateUI_select_COUNTRY_reload_CURRENCY_b ";
    if(api.print_logs){console.log(methName+'ctry_wu_id='+ctry_wu_id);}

    for (let i=0; i<this.state.parserObject_getCurrencies_ALL.length && ctry_wu_id !==""; ++i) {
        let item = this.state.parserObject_getCurrencies_ALL[i];
        if(ctry_wu_id === item.ctry_wu_id){
            let countryCurrencies = item["currencies"];
            if(countryCurrencies.length===1){
                //localStorage.setItem("parserObject_getCurrencies4CountryRec_isD2B",    item[api.hasD2BfName]===true?"true":"false");
                //localStorage.setItem("parserObject_getCurrencies4CountryRec_localCur", item["localCur"]);
                //this.setState({ "viewTM_view_BA_isHidden" : (item[api.hasD2BfName]===true) ? false : true });

                let parserObject_getCurrencies4Picker= [];
                for(let ii=0; ii<countryCurrencies.length; ++ii){ parserObject_getCurrencies4Picker.push(countryCurrencies[ii]["curr_descr"]); }
                this.setState({
                  "parserObject_getCurrencies_b"        : countryCurrencies,
                  "parserObject_getCurrencies4Picker_b" : parserObject_getCurrencies4Picker,
                  "picker3b_selIndex_currencyReceive"   : 0,
                  "picker3b_textFieldLabel1_text"       : countryCurrencies[0]["curr_descr"],
                  "picker3b_textFieldLabel1_id"         : countryCurrencies[0]["curr_iso_id"],
                  "picker3b_textFieldLabel1_hasError"   : false,
                });
                if(api.print_logs){console.log('[1] ctry_wu_id='+ctry_wu_id+',parserObject_getCurrencies4Picker='+parserObject_getCurrencies4Picker);}
            }
            else if(countryCurrencies.length>1){
                //localStorage.setItem("parserObject_getCurrencies4CountryRec_isD2B",    item[api.hasD2BfName]===true?"true":"false");
                //localStorage.setItem("parserObject_getCurrencies4CountryRec_localCur", item["localCur"]);
                //this.setState({ "viewTM_view_BA_isHidden" : (item[api.hasD2BfName]===true) ? false : true });

                //5Α16
                //countryCurrencies = [{curr_iso_id:"",curr_descr:this.NSInforString("TransferOnline_pic3")}].concat(countryCurrencies);

                let parserObject_getCurrencies4Picker= [];
                for(let ii=0; ii<countryCurrencies.length; ++ii){ parserObject_getCurrencies4Picker.push(countryCurrencies[ii]["curr_descr"]); }
                this.setState({
                  "parserObject_getCurrencies_b"        : countryCurrencies,
                  "parserObject_getCurrencies4Picker_b" : parserObject_getCurrencies4Picker,
                  "picker3b_selIndex_currencyReceive"   : 0,
                  "picker3b_textFieldLabel1_text"       : countryCurrencies[0]["curr_descr"],
                  "picker3b_textFieldLabel1_id"         : countryCurrencies[0]["curr_iso_id"],
                  "picker3b_textFieldLabel1_hasError"   : false,
                });
                if(api.print_logs){console.log('[1] ctry_wu_id='+ctry_wu_id+',parserObject_getCurrencies4Picker='+parserObject_getCurrencies4Picker);}
            }
            break;
        }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------RadioButton Listeners-----------------------------
  //----------------------------------------------------------------------------------------------------
  handleRadioButtonClick_changeReceiver(event) {
    let methName = filename+"handleRadioButtonClick_changeReceiver ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}

    if(eventTMP==="true"){
      this.setState({
        "changeReceiver_value"              : "true",
        "changeDestination_value"           : "",
        "textField4_disabled"               : false,
        "textField5_disabled"               : false,
        "picker2b_disabled"                 : true,
        "picker3b_disabled"                 : true,
        "picker4b_disabled"                 : true,
        "picker5b_disabled"                 : true,
        "picker2b_textFieldLabel1_hasError" : false,
        "picker3b_textFieldLabel1_hasError" : false,
      });
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleRadioButtonClick_changeDestination(event) {
    let methName = filename+"handleRadioButtonClick_changeDestination ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}

    if(eventTMP==="true"){
      this.setState({
        "changeReceiver_value"              : "",
        "changeDestination_value"           : "true",
        "textField4_disabled"               : true,
        "textField5_disabled"               : true,
        "picker2b_disabled"                 : false,
        "picker3b_disabled"                 : false,
        "picker4b_disabled"                 : false,
        "picker5b_disabled"                 : false,
        "textField4_hasError"               : false,
        "textField5_hasError"               : false,
      });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_paymentMethod(event) {
    let methName = filename+"handleCustomDropDownClick_paymentMethod ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "picker1_textFieldLabel1_text"     : eventTMP,
      "picker1_textFieldLabel1_hasError" : false,
    });
    for(let i=0; i<this.state.parserObject_getPaymentMethods.length; ++i){
      //console.log(eventTMP+"==="+this.state.parserObject_getPaymentMethods[i]["descr_el"]+"==="+this.state.parserObject_getPaymentMethods[i]["descr_en"]);
      if( this.state.parserObject_getPaymentMethods[i]["descr_el"]===eventTMP || this.state.parserObject_getPaymentMethods[i]["descr_en"]===eventTMP ){
        this.setState({
          "picker1_textFieldLabel1_id" : this.state.parserObject_getPaymentMethods[i].payment_method_wu_id
        });
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_countrya(event,value) {
    let methName = filename+"handleCustomDropDownClick_countrya ";
    let event_target_value = null;
    let eventTMP1          = null;
    let eventTMP2          = null;
    if(this.state.picker2a_AUTOCOMPLETE_MODE === "text"){
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    }
    else{
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value.descr_en;
    }
    if(api.print_logs){console.log(methName+"eventTMP1 = " + eventTMP1);}
    if(api.print_logs){console.log(methName+"eventTMP2 = " + eventTMP2);}
    if(api.print_logs){console.log(methName+"event     = " + event);}
    if(api.print_logs){console.log(methName+"value     = " + value);}

    this.setState({
      "picker2a_textFieldLabel1_text"     : eventTMP1,
      "picker2a_textFieldLabel1_hasError" : false,
    });
    for(let i=0; i<this.state.parserObject_getCountries4Picker.length; ++i){
      if(this.state.parserObject_getCountries4Picker[i]===eventTMP2){
        this.setState({
          "picker2a_selIndex"           : i,
          "picker2a_textFieldLabel1_id" : this.state.parserObject_getCountries[i].ctry_wu_id
        });
        let ctry_wu_id_TMP = this.state.parserObject_getCountries[i].ctry_wu_id;
        this.updateUI_select_COUNTRY_reload_CURRENCY(ctry_wu_id_TMP);
        if(ctry_wu_id_TMP==="US" || ctry_wu_id_TMP==="MX"){
          this.makeHTTPConn_select_COUNTRY_reload_STATE_a(ctry_wu_id_TMP);
        }
        else{
          this.setState({ "viewStatea_isHidden":true });
        }
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_statea(event) {
    let methName = filename+"handleCustomDropDownClick_statea ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "picker4a_textFieldLabel1_text"     : eventTMP,
      "picker4a_textFieldLabel1_hasError" : false,
    });
    for(let i=0; i<this.state.parserObject_getStates4Pickera.length; ++i){
      if(this.state.parserObject_getStates4Pickera[i]===eventTMP){
        this.setState({
          "picker4a_selIndex_State"     : i,
          "picker4a_textFieldLabel1_id" : this.state.parserObject_getStatesa[i].state_id,
        });
        let ctry_wu_id_TMP = this.state.picker2a_textFieldLabel1_id;
        let state_id_TMP   = this.state.parserObject_getStatesa[i].state_id;
        console.log(methName+"ctry_wu_id_TMP="+ctry_wu_id_TMP+",state_id_TMP="+state_id_TMP);
        if(ctry_wu_id_TMP==="MX"){
          this.makeHTTPConn_select_STATE_reload_CITY_a(ctry_wu_id_TMP,state_id_TMP);
        }
        else{
          this.setState({ "viewCitya_isHidden":true });
        }
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_citya(event) {
    let methName = filename+"handleCustomDropDownClick_citya ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "picker5a_textFieldLabel1_text"     : eventTMP,
      "picker5a_textFieldLabel1_hasError" : false,
    });
    for(let i=0; i<this.state.parserObject_getCities4Pickera.length; ++i){
      if(this.state.parserObject_getCities4Pickera[i]===eventTMP){
        this.setState({
          "picker5a_selIndex_City"      : i,
          "picker5a_textFieldLabel1_id" : this.state.parserObject_getCitiesa[i].city_id
        });
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_currencya(event) {
    let methName = filename+"handleCustomDropDownClick_currencya ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "picker3a_textFieldLabel1_text"     : eventTMP,
      "picker3a_textFieldLabel1_hasError" : false,
    });
    for(let i=0; i<this.state.parserObject_getCurrencies4Picker.length; ++i){
      if(this.state.parserObject_getCurrencies4Picker[i]===eventTMP){
        this.setState({ "picker3a_selIndex_currencyReceive" :  i });
        this.setState({ "picker3a_textFieldLabel1_id"       :  this.state.parserObject_getCurrencies[i].curr_iso_id });
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_countryb(event,value) {
    let methName = filename+"handleCustomDropDownClick_countryb ";
    let event_target_value = null;
    let eventTMP1          = null;
    let eventTMP2          = null;
    if(this.state.picker2b_AUTOCOMPLETE_MODE === "text"){
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    }
    else{
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value.descr_en;
    }
    if(api.print_logs){console.log(methName+"eventTMP1 = " + eventTMP1);}
    if(api.print_logs){console.log(methName+"eventTMP2 = " + eventTMP2);}
    if(api.print_logs){console.log(methName+"event     = " + event);}
    if(api.print_logs){console.log(methName+"value     = " + value);}

    this.setState({
      "picker2b_textFieldLabel1_text"     : eventTMP1,
      "picker2b_textFieldLabel1_hasError" : false,
    });
    for(let i=0; i<this.state.parserObject_getCountries4Picker.length; ++i){
      if(this.state.parserObject_getCountries4Picker[i]===eventTMP2){
        this.setState({
          "picker2b_selIndex"           : i,
          "picker2b_textFieldLabel1_id" : this.state.parserObject_getCountries[i].ctry_wu_id
        });
        let ctry_wu_id_TMP = this.state.parserObject_getCountries[i].ctry_wu_id;
        this.updateUI_select_COUNTRY_reload_CURRENCY_b(ctry_wu_id_TMP);
        if(ctry_wu_id_TMP==="US" || ctry_wu_id_TMP==="MX"){
          this.makeHTTPConn_select_COUNTRY_reload_STATE_b(ctry_wu_id_TMP);
        }
        else{
          this.setState({ "viewStateb_isHidden":true });
        }
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_stateb(event) {
    let methName = filename+"handleCustomDropDownClick_stateb ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "picker4b_textFieldLabel1_text"     : eventTMP,
      "picker4b_textFieldLabel1_hasError" : false,
    });
    for(let i=0; i<this.state.parserObject_getStates4Pickerb.length; ++i){
      if(this.state.parserObject_getStates4Pickerb[i]===eventTMP){
        this.setState({
          "picker4b_selIndex_State"     : i,
          "picker4b_textFieldLabel1_id" : this.state.parserObject_getStatesb[i].state_id
        });
        let ctry_wu_id_TMP = this.state.picker2b_textFieldLabel1_id;
        let state_id_TMP   = this.state.parserObject_getStatesb[i].state_id;
        console.log(methName+"ctry_wu_id_TMP="+ctry_wu_id_TMP+",state_id_TMP="+state_id_TMP);
        if(ctry_wu_id_TMP==="MX"){
          this.makeHTTPConn_select_STATE_reload_CITY_b(ctry_wu_id_TMP,state_id_TMP);
        }
        else{
          this.setState({ "viewCityb_isHidden":true });
        }
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_cityb(event) {
    let methName = filename+"handleCustomDropDownClick_cityb ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "picker5b_textFieldLabel1_text"     : eventTMP,
      "picker5b_textFieldLabel1_hasError" : false,
    });
    for(let i=0; i<this.state.parserObject_getCities4Pickerb.length; ++i){
      if(this.state.parserObject_getCities4Pickerb[i]===eventTMP){
        this.setState({
          "picker5b_selIndex_State"     : i,
          "picker5b_textFieldLabel1_id" : this.state.parserObject_getCitiesb[i].city_id
        });
        console.log('eventTMP='+eventTMP+",this.state.parserObject_getCitiesb[i].city_id="+this.state.parserObject_getCitiesb[i].city_id);
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_currencyb(event) {
    let methName = filename+"handleCustomDropDownClick_currencyb ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "picker3b_textFieldLabel1_text"     : eventTMP,
      "picker3b_textFieldLabel1_hasError" : false,
    });
    for(let i=0; i<this.state.parserObject_getCurrencies4Picker_b.length; ++i){
      if(this.state.parserObject_getCurrencies4Picker_b[i]===eventTMP){
        this.setState({ "picker3b_selIndex_currencyReceive" : i });
        this.setState({ "picker3b_textFieldLabel1_id"       : this.state.parserObject_getCurrencies_b[i].curr_iso_id });
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_next_act_isDisabled(){
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act(){
      let methName = filename+"btn_next_act ";
      if(api.print_logs){console.log(methName);}

      //++++++++++++++++++++++
      //webapp session timeout
      //++++++++++++++++++++++
      if(wu_Utilities.checkIfUserIsLoggedIn()){
        wu_Utilities.update_uilatstats();
        if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
      }
      //+++++++++++++++++++++++
      //validate Only Emptyness
      //+++++++++++++++++++++++
      let validateOnlyEmptyness = true;
      if(validateOnlyEmptyness){
        let emptyFields = false;
        if(this.state.picker1_textFieldLabel1_text  ==="") { this.setState({"picker1_textFieldLabel1_hasError"  : true }); emptyFields = true; }
        if(this.state.picker2a_textFieldLabel1_text ==="") { this.setState({"picker2a_textFieldLabel1_hasError" : true }); emptyFields = true; } //picker2a_AUTOCOMPLETE_MODE(do not trim)
        if(this.state.picker3a_textFieldLabel1_text ==="") { this.setState({"picker3a_textFieldLabel1_hasError" : true }); emptyFields = true; }
        if(this.state.textField1.trim() === "") { this.setState({"textField1_hasError" : true }); emptyFields = true; }
        if(this.state.textField2.trim() === "") { this.setState({"textField2_hasError" : true }); emptyFields = true; }
        if(this.state.textField3.trim() === "") { this.setState({"textField3_hasError" : true }); emptyFields = true; }
        if(this.state.changeReceiver_value==="true"){
          if(this.state.textField4.trim() === "") { this.setState({"textField4_hasError" : true }); emptyFields = true; }
          if(this.state.textField5.trim() === "") { this.setState({"textField5_hasError" : true }); emptyFields = true; }
        }
        else{
          if(this.state.picker2b_textFieldLabel1_text ==="") { this.setState({"picker2b_textFieldLabel1_hasError" : true }); emptyFields = true; } //picker2b_AUTOCOMPLETE_MODE(do not trim)
          if(this.state.picker3b_textFieldLabel1_text ==="") { this.setState({"picker3b_textFieldLabel1_hasError" : true }); emptyFields = true; }
        }
        if(emptyFields===true){return;}
      }



      //-------------
      //validate mtcn---TextField
      //-------------
      let mtcn           = this.state.textField1.trim();
      let textField1text = this.state.textField1.trim();
      if(textField1text === ""){
        this.setState({"textField1_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("History3_plh01")+"\"");
        return;
      }
      if(this.verifyGenericItem("MTCN",textField1text)===false){
        this.setState({"textField1_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.mtcn.digits"));
        return;
      }
      //-----------------------
      //validate Payment Method
      //-----------------------
      let PaymentMethod = this.state.picker1_textFieldLabel1_id;
      if(PaymentMethod === ""){
          this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("History3_pic1")+"\"");
          return;
      }
      //--------------------------
      //validate receiverFirstName---TextField
      //--------------------------
      let receiverFirstName = this.state.textField2.trim();
      let textField2text    = this.state.textField2.trim();
      if(textField2text === ""){
        this.setState({"textField2_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("History3_plh03")+"\"");
        return;
      }
      if(wu_Utilities.offline_validate_latinCharacters(textField2text.replace(/ /g,""))===false){
        this.setState({"textField2_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("History3_plh03")+"\" "+this.NSInforString("with_latin"));
        return;
      }
      if(textField2text.length < 2 || textField2text.length > 36){
        this.setState({"textField2_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.firstName.size"));
        return;
      }
      //-------------------------
      //validate receiverLastName---TextField
      //-------------------------
      let receiverLastName = this.state.textField3.trim();
      let textField3text   = this.state.textField3.trim();
      if(textField3text === ""){
        this.setState({"textField3_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("History3_plh04")+"\"");
        return;
      }
      if(wu_Utilities.offline_validate_latinCharacters(textField3text.replace(/ /g,""))===false){
        this.setState({"textField3_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("History3_plh04")+"\" "+this.NSInforString("with_latin"));
        return;
      }
      if(textField3text.length < 2 || textField3text.length > 36){
        this.setState({"textField3_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.lastName.size"));
        return;
      }
      //---------------------------
      //validate firstName+lastName---TextField
      //---------------------------
      if(textField2text.length + textField3text.length > 39){
        this.setState({"textField2_hasError" : true });
        this.setState({"textField3_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.firstlastName.size"));
        return;
      }
      //--------------------
      //validate countryWuId---Picker
      //--------------------
      let countryWuId = this.state.picker2a_textFieldLabel1_id;
      if(countryWuId ===""){
        this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("History3_pic2"));
        return;
      }
      //--------------
      //validate State
      //--------------
      let stateId = "";
      if(this.state.viewStatea_isHidden === false){
        stateId = this.state.picker4a_textFieldLabel1_id;
        if(stateId === ""){
          this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("History3_pic4"));
          return;
        }
      }
      //-------------
      //validate City
      //-------------
      let city_id_a = "";
      if(this.state.viewCitya_isHidden === false){
        city_id_a = this.state.picker5a_textFieldLabel1_id;
        if(city_id_a === ""){
            this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("History3_pic5"));
            return;
        }
      }
      //-----------------
      //validate currency
      //-----------------
      let receiverCurrencyId = this.state.picker3a_textFieldLabel1_id;
      if(receiverCurrencyId === ""){
        this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("History3_pic3"));
        return;
      }

      if(api.print_logs){console.log("mtcn               = "+mtcn);               }
      if(api.print_logs){console.log("receiverFirstName  = "+receiverFirstName);  }
      if(api.print_logs){console.log("receiverLastName   = "+receiverLastName);   }
      if(api.print_logs){console.log("countryWuId        = "+countryWuId);        }
      if(api.print_logs){console.log("stateId            = "+stateId);            }
      if(api.print_logs){console.log("city_id            = "+city_id_a);          }
      if(api.print_logs){console.log("receiverCurrencyId = "+receiverCurrencyId); }

      if(api.print_logs){console.log("this.state.changeReceiver_value    = "+this.state.changeReceiver_value); }
      if(api.print_logs){console.log("this.state.changeDestination_value = "+this.state.changeDestination_value); }
      let parserObject_ammendTransaction_req = {};
      if(this.state.changeReceiver_value==="true"){
          //-----------------------------
          //validate receiverNewFirstName---TextField
          //-----------------------------
          let receiverNewFirstName = this.state.textField4.trim();
          let textField4text       = this.state.textField4.trim();
          if(textField4text === ""){
            this.setState({"textField4_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("History3_plh03")+"\"");
            return;
          }
          if(wu_Utilities.offline_validate_latinCharacters(textField4text.replace(/ /g,""))===false){
            this.setState({"textField4_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("History3_plh03")+"\" "+this.NSInforString("with_latin"));
            return;
          }
          if(textField4text.length < 2 || textField4text.length > 36){
            this.setState({"textField4_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.firstName.size"));
            return;
          }
          //----------------------------
          //validate receiverNewLastName---TextField
          //----------------------------
          let receiverNewLastName = this.state.textField5.trim();
          let textField5text      = this.state.textField5.trim();
          if(textField5text === ""){
            this.setState({"textField5_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("History3_plh04")+"\"");
            return;
          }
          if(wu_Utilities.offline_validate_latinCharacters(textField5text.replace(/ /g,""))===false){
            this.setState({"textField5_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("History3_plh04")+"\" "+this.NSInforString("with_latin"));
            return;
          }
          if(textField5text.length < 2 || textField5text.length > 36){
            this.setState({"textField5_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.lastName.size"));
            return;
          }
          //---------------------------
          //validate firstName+lastName---TextField
          //---------------------------
          if(textField4text.length + textField5text.length > 39){
            this.setState({"textField4_hasError" : true });
            this.setState({"textField5_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.firstlastName.size"));
            return;
          }

          parserObject_ammendTransaction_req["mtcn"]                  = mtcn;
          parserObject_ammendTransaction_req["countryWuId"]           = countryWuId;
          parserObject_ammendTransaction_req["stateId"]               = stateId;
          parserObject_ammendTransaction_req["cityId"]                = city_id_a;
          parserObject_ammendTransaction_req["receiverCurrencyId"]    = receiverCurrencyId;
          parserObject_ammendTransaction_req["receiverFirstName"]     = receiverFirstName;
          parserObject_ammendTransaction_req["receiverLastName"]      = receiverLastName;
          parserObject_ammendTransaction_req["receiverNewFirstName"]  = receiverNewFirstName;
          parserObject_ammendTransaction_req["receiverNewLastName"]   = receiverNewLastName;
          parserObject_ammendTransaction_req["newCountryWuId"]        = "";
          parserObject_ammendTransaction_req["stateIdNew"]            = "";
          parserObject_ammendTransaction_req["cityIdNew"]             = "";
          parserObject_ammendTransaction_req["receiverNewCurrencyId"] = "";
          parserObject_ammendTransaction_req["amendTransactionType"]  = "1";
          parserObject_ammendTransaction_req["txnChannel"]            = PaymentMethod;
      }
      else{
          //----------------------
          //validate countryWuId_b---Picker
          //----------------------
          let countryWuId_b = this.state.picker2b_textFieldLabel1_id;
          if(countryWuId_b ===""){
            this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("History3_pic2b"));
            return;
          }
          //----------------
          //validate State_b
          //----------------
          let stateId_b = "";
          if(this.state.viewStateb_isHidden === false){
            stateId_b = this.state.picker4b_textFieldLabel1_id;
            if(stateId_b === ""){
                this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("History3_pic4b"));
                return;
            }
          }
          //---------------
          //validate City_b
          //---------------
          let city_id_b = "";
          if(this.state.viewCityb_isHidden === false){
            city_id_b = this.state.picker5b_textFieldLabel1_id;
            if(city_id_b === ""){
                this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("History3_pic5b"));
                return;
            }
          }
          //------------------
          //validate currencyb
          //------------------
          let receiverCurrencyId_b = this.state.picker3b_textFieldLabel1_id;
          if(receiverCurrencyId_b === ""){
            this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("History3_pic3b"));
            return;
          }

          if(api.print_logs){console.log("countryWuId_b        = "+countryWuId_b);  }
          if(api.print_logs){console.log("stateId_b            = "+stateId_b);  }
          if(api.print_logs){console.log("city_id_b            = "+city_id_b);  }
          if(api.print_logs){console.log("receiverCurrencyId_b = "+receiverCurrencyId_b);  }

          parserObject_ammendTransaction_req["mtcn"]                  = mtcn;
          parserObject_ammendTransaction_req["countryWuId"]           = countryWuId;
          parserObject_ammendTransaction_req["stateId"]               = stateId;
          parserObject_ammendTransaction_req["cityId"]                = city_id_a;
          parserObject_ammendTransaction_req["receiverCurrencyId"]    = receiverCurrencyId;
          parserObject_ammendTransaction_req["receiverFirstName"]     = receiverFirstName;
          parserObject_ammendTransaction_req["receiverLastName"]      = receiverLastName;
          parserObject_ammendTransaction_req["receiverNewFirstName"]  = "";
          parserObject_ammendTransaction_req["receiverNewLastName"]   = "";
          parserObject_ammendTransaction_req["newCountryWuId"]        = countryWuId_b;
          parserObject_ammendTransaction_req["stateIdNew"]            = stateId_b;
          parserObject_ammendTransaction_req["cityIdNew"]             = city_id_b;
          parserObject_ammendTransaction_req["receiverNewCurrencyId"] = receiverCurrencyId_b;
          parserObject_ammendTransaction_req["amendTransactionType"]  = "2";
          parserObject_ammendTransaction_req["txnChannel"]            = PaymentMethod;
      }

      this.startSpinners();
      setTimeout(function() { //Start the timer
        //--------------------
        //wu_ammendTransaction
        //--------------------
        wu_HistoryService
        .wu_ammendTransaction(parserObject_ammendTransaction_req)
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="HistoryChange"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          this.stopSpinners();
          this.dialog2_handleOpen(this.NSInforString("History3_successMessage"));
        })
        .catch(err => {
          this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
        });
      }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    // if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
    //   this.setState({"textField0":eventTMP.trim(),});
    // }
    if(stateVar==="textField1"){
      //eventTMP = eventTMP.toUpperCase();
      this.setState({
        "textField1"          : eventTMP,
        "textField1_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_numericCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.digits")); this.setState({"textField1_hasError":true}); return; }
    }
    else if(stateVar==="textField2"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "textField2"          : eventTMP,
        "textField2_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField2_hasError":true}); return; }
      if(eventTMP.length > 36){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstName.size")); this.setState({"textField2_hasError":true}); return; }
      if(eventTMP.trim().length + this.state.textField3.trim().length > 39){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstlastName.size")); this.setState({"textField2_hasError":true, "textField3_hasError":true}); return; }
      else                                                                 { this.setState({"textField2_hasError":false, "textField3_hasError":false}); }
    }
    else if(stateVar==="textField3"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "textField3"          : eventTMP,
        "textField3_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField2_hasError":true}); return; }
      if(eventTMP.length > 36){ this.Snackbar_textField_handleOpen(this.NSInforString("common.lastName.size")); this.setState({"textField3_hasError":true}); return; }
      if(this.state.textField2.trim().length + eventTMP.trim().length > 39){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstlastName.size")); this.setState({"textField2_hasError":true, "textField3_hasError":true}); return; }
      else                                                                 { this.setState({"textField2_hasError":false, "textField3_hasError":false}); }
    }
    else if(stateVar==="textField4"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "textField4"          : eventTMP,
        "textField4_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField4_hasError":true}); return; }
      if(eventTMP.length > 36){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstName.size")); this.setState({"textField4_hasError":true}); return; }
      if(eventTMP.trim().length + this.state.textField5.trim().length > 39){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstlastName.size")); this.setState({"textField4_hasError":true, "textField5_hasError":true}); return; }
      else                                                                 { this.setState({"textField4_hasError":false, "textField5_hasError":false}); }
    }
    else if(stateVar==="textField5"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "textField5"          : eventTMP,
        "textField5_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField5_hasError":true}); return; }
      if(eventTMP.length > 36){ this.Snackbar_textField_handleOpen(this.NSInforString("common.lastName.size")); this.setState({"textField5_hasError":true}); return; }
      if(this.state.textField4.trim().length + eventTMP.trim().length > 39){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstlastName.size")); this.setState({"textField4_hasError":true, "textField5_hasError":true}); return; }
      else                                                                 { this.setState({"textField4_hasError":false, "textField5_hasError":false}); }
    }
    else{
      this.setState({ [stateVar]:eventTMP });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="MTCN")                             { return wu_Utilities.wu_verifyMTCN(val);  }
    if(key==="firstName")                        { return wu_Utilities.offline_validate_firstName(val); }
    if(key==="lastName")                         { return wu_Utilities.offline_validate_lastName(val);  }

    return false;
  }
  importAll(r) {
    //return r.keys().map(r);
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace('./', '')] = r(item);
      return "";
    });
    return images;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups2--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog2_handleOpen(dialog2_msg){
    this.setState({ "dialog2_isOpen" : true });
    this.setState({ "dialog2_msg"    : dialog2_msg });
  }
  dialog2_handleClose(){
    this.setState({ "dialog2_isOpen": false });
    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  removeNonWuCountries(countries){
    let countriesNew = [];
    for(let i=0; i<countries.length; ++i){
      if(countries[i].isWu===true){countriesNew.push(countries[i]);}
    }
    if(countriesNew.length===0){return countries;}
    return countriesNew;
  }
  //----------------------------------------------------------------------------------------------------
}
HistoryChange.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(HistoryChangeStyle)(HistoryChange)
);
